'use client';

const newWindowIndication = "(Opens in new window)";
const defaultDoneLabel = "Done";
export {
  defaultDoneLabel,
  newWindowIndication
};
